import React from 'react';
import { SignUp } from 'aws-amplify-react';

class CustomSignUp extends SignUp {
  public constructor(props: any) {
    super(props);

    this._validAuthStates = ['signUp'];
  }

  public showComponent(): JSX.Element {
    this.changeState('signIn');
    return null;
  }
}

export default CustomSignUp;
